import {
  Bar,
  CartesianGrid,
  Cell,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

const COLOR_COHORT = "#10B415"
const COLOR_LINE = "#0A66CC"
const COLOR_STUDENT_DEFAULT = "#ef4444"

function xTicks(maxScore: number): number[] {
  const step = maxScore <= 10 ? 2 : maxScore <= 25 ? 5 : 10
  const ticks: number[] = []
  for (let i = 0; i <= maxScore; i += step) ticks.push(i)
  if (ticks[ticks.length - 1] !== maxScore) ticks.push(maxScore)
  return ticks
}

interface DistributionChartProps {
  bins: Array<{ score: number; pct: number }>
  maxScore: number
  studentScore?: number
  height?: number
  studentBarColor?: string
}

export function DistributionChart({
  bins,
  maxScore,
  studentScore,
  height = 160,
  studentBarColor = COLOR_STUDENT_DEFAULT,
}: DistributionChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart
        data={bins}
        margin={{ top: 8, right: 8, left: 0, bottom: 20 }}
      >
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#E5E7EB"
        />
        <XAxis
          dataKey="score"
          tickLine={false}
          axisLine={{ stroke: "#D1D5DB" }}
          fontSize={10}
          ticks={xTicks(maxScore)}
          label={{
            value: "Raw score",
            position: "insideBottom",
            offset: -10,
            fontSize: 10,
            fill: "#9CA3AF",
          }}
        />
        <YAxis
          tickLine={false}
          axisLine={false}
          fontSize={10}
          tickCount={4}
          tickFormatter={(v: number) => `${v}%`}
          width={32}
          tick={{ fill: "#9CA3AF" }}
        />
        <Tooltip
          formatter={(value: number) => [`${value.toFixed(1)}%`, "Students"]}
          labelFormatter={(label: number) => `Score: ${label}`}
          contentStyle={{ fontSize: 12, borderRadius: 6 }}
          cursor={{ fill: "rgba(0,0,0,0.04)" }}
        />
        <Bar dataKey="pct" radius={[2, 2, 0, 0]}>
          {bins.map((entry, idx) => (
            <Cell
              key={`${entry.score}-${idx}`}
              fill={
                studentScore !== undefined && entry.score === studentScore
                  ? studentBarColor
                  : COLOR_COHORT
              }
              fillOpacity={
                studentScore !== undefined && entry.score === studentScore
                  ? 1
                  : 0.65
              }
            />
          ))}
        </Bar>
        <Line
          type="monotone"
          dataKey="pct"
          dot={false}
          stroke={COLOR_LINE}
          strokeWidth={2}
          strokeOpacity={0.8}
        />
      </ComposedChart>
    </ResponsiveContainer>
  )
}
